import React from 'react';
import { withFirebase } from '../Firebase';
import { Navbar, Nav, NavItem } from "react-bootstrap";




const SignOutButton = ({ firebase }) => (
    <Nav.Item>
        <Nav.Link onSelect={firebase.doSignOut}>
            Sign Out
            </Nav.Link>
    </Nav.Item>

);

export default withFirebase(SignOutButton);